import Alert from '@reach/alert';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar, tailwindOverride } from '@getsynapse/design-system';
import {
  getAllNotifications,
  hideNotification,
} from 'state/SnackbarNotification/SnackbarNotificationSlice';

const SnackbarNotification = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(getAllNotifications);

  return (
    <Alert className='fixed bottom-12 left-6 z-high' type='assertive'>
      <div className='flex flex-col gap-2'>
        {notifications.map((notification) => (
          <Snackbar
            key={notification.id}
            variant={notification.notificationVariant}
            title={notification.notificationTitle}
            message={notification.notificationMessage}
            hasCloseButton={!notification.autoHide}
            autoHideDuration={notification.timeout}
            onCloseCallback={() => dispatch(hideNotification(notification.id))}
            data-cy='snackbar-notification'
            className={tailwindOverride(
              'relative bg-neutral-white',
              'animate-snackarNotification'
            )}
          />
        ))}
      </div>
    </Alert>
  );
};

export default SnackbarNotification;
